import React from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from 'reactstrap';

import { classes } from './modalClasses';

export const ConfirmationModal = (props) => {
  const { t } = useTranslation();
  return (
    <Modal style={classes.modalCustom} isOpen={props.open}>
      <div style={classes.modalHeader} className="modal-header">
        <h5 style={classes.title} className="modal-title">
          {t('Vous êtes sûr')} ?
        </h5>
        <button
          type="button"
          onClick={props.handleClose}
          style={classes.btnClose}
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        />
      </div>
      <div style={classes.modalPad} className="modal-body">
        <div className="row row-mb-lg">
          <div className="col-12 col-md-12">
            <div style={classes.textConfirm}>{props.message}</div>
          </div>
        </div>
        <div style={classes.boxBtConfirm}>
          <button
            style={{
              padding: '10px 20px',
              border: '1px solid #E2E2E2',
              borderRadius: 6,
              background: '#FFFFFF',
              color: '#1A1A1A',
              fontSize: 14,
              fontWeight: 500,
              cursor: 'pointer',
            }}
            onClick={props.handleClose}
            className="confirmation-modal-cancel-button me-2"
          >
            {props.isReload ? t('Non, revenir en arrière') : t('Annuler')}
          </button>
          <button
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: 6,
              background: '#6458F1',
              color: '#FFFFFF',
              fontSize: 14,
              fontWeight: 500,
              cursor: 'pointer',
            }}
            onClick={props.executeAction}
            className="confirmation-modal-confirm-button"
          >
            {props.isReload ? t('Je suis sûr(e)') : t('Confirmer')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
